<template>
  <div class="d-flex flex-column height-100">
    <Header />
    <div class="d-flex flex-column flex-1 dot-grid-background main-container">
      <slot name="main" />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'

export default {
  name: 'StandardLayout',
  components: {
    Header,
  },
}
</script>
<style lang="scss">
  .dot-grid-background {
    background: url('@/assets/dot-grid.webp') repeat;
  }
  .main-container {
    /* Allow flex children to shrink and enable nested scroll areas */
    min-height: 0;
    height: calc(100vh - 66px);
  }
</style>